module.exports = __webpack_public_path__ + "static/media/breakfast-gummy.929ae7ab.jpeg";